import styled from 'styled-components';

export const GroupingTableContainer = styled.div`
  padding: 16px;
`;

export const GroupingTableHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 8px;
`;

export const GroupingTableWrapper = styled.div`
  margin-top: 8px;
`;

export const FileSwitcherWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const GroupingTableContentWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
